import { useField } from 'formik';
import React from 'react';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';

export interface IDisbursementToBeDeletedProps {
  feeName: string;
}

export const DisbursementToBeDeleted: React.FC<IDisbursementToBeDeletedProps> = ({ feeName }) => {
  const [, , { setValue }] = useField<boolean | undefined>(`value.isDeleting`);

  return (
    <div className={'my-4 w-full rounded-2xl border-[1px] border-coolGray-100 bg-white p-4 shadow'}>
      <div className={'flex flex-row items-center'}>
        <div className={'flex-grow text-xl font-semibold'}>Fee - {feeName} Disbursement</div>
        <ButtonTW ghost className={'text-red-400'} secondary onClick={() => setValue(false)}>
          Cancel Deletion
        </ButtonTW>
      </div>
      <div className={'my-4 flex basis-full flex-wrap gap-1'}>
        <div>This disbursement will be deleted the next time this fee is updated</div>
      </div>
    </div>
  );
};
